import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Conflict from '../../entities/conflict';

/*
 * Delete/nullify anywhere this conflict is used in other entities
 *
 * @param {Conflict} conflict
 */
export function deleteConflict(conflict: Conflict, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = conflict.id;
    }

    /* Remove the actual conflict */
    conflict.status = 'D';
    conflict.addedOn = newHRTimestamp();
    conflict.addedBy = getCurrentUserId();
    conflict.importSource = targetImportSource;
    conflict.importId = mergeId;
    store.dispatch(Actions.ConflictActions.removeConflictQueue(conflict));
    
}